import { notification } from "antd";

import axios from '../../../config/axios'

// constant
import { BASE_URL_BETA } from "../../../constant/api";

const getListData = async (listType: string, company_id: number) => {
  try {
    let queryParams = new URLSearchParams({
      list_type: listType,
      company_id: company_id,
    } as any).toString();
    
    const url = `${BASE_URL_BETA}/admin/export-data?${queryParams}`;
    const response = await axios.get(url);

    if (response && response.status === 200) {
        return response.data.collections
    }
  } catch (err) {
    notification.error({
      message: "Gagal memuat",
      placement: "topRight",
      duration: 2,
    });
    // throw new Error(err);
  }
};

export default getListData;